import { useState } from 'react';
import { Plus, Search } from 'lucide-react';
import { useAuthStore } from '@/stores/auth';
import { api } from '@/lib/api';
import { useGlobalKeybindings } from '@/lib/keybindings';
import { Button } from './ui/button';
import { AlertsDropdown } from './AlertsDropdown';
import { AddItemModal } from './AddItemModal';
import { SearchPalette } from './SearchPalette';

export function Topbar(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const [addOpen, setAddOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  // Atalhos globais — Cmd+K (busca) + G+letra (nav) via useGlobalKeybindings
  useGlobalKeybindings(() => setSearchOpen((v) => !v));

  async function handleLogout(): Promise<void> {
    try {
      await api('/api/auth/logout', { method: 'POST' });
    } catch {
      // desloga local mesmo se API falhar
    }
    useAuthStore.getState().clearAuth();
    window.location.href = '/login';
  }

  return (
    <>
      <header className="flex h-12 items-center justify-between border-b border-border bg-card px-4">
        <div className="flex items-center gap-3">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground font-bold text-xs">
            CT
          </div>
          <span className="font-semibold">
            Central da <span className="font-bold">Tata</span>
          </span>
        </div>

        <div className="flex flex-1 max-w-xl mx-6">
          <button
            type="button"
            onClick={() => setSearchOpen(true)}
            className="flex items-center gap-2 w-full px-3 py-1.5 rounded-md border border-input bg-background text-sm text-muted-foreground hover:bg-accent transition-colors"
          >
            <Search className="h-4 w-4" />
            <span>Buscar…</span>
            <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium">
              ⌘K
            </kbd>
          </button>
        </div>

        <div className="flex items-center gap-2">
          <Button size="sm" variant="default" className="gap-1" onClick={() => setAddOpen(true)}>
            <Plus className="h-4 w-4" />
            Adicionar
          </Button>
          <AlertsDropdown />
          <div className="flex items-center gap-2 pl-2 border-l border-border ml-2">
            <div className="h-7 w-7 rounded-full bg-primary/20 flex items-center justify-center text-xs font-medium">
              {user?.nome.charAt(0).toUpperCase() ?? '?'}
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="text-xs text-muted-foreground hover:text-foreground"
            >
              Sair
            </button>
          </div>
        </div>
      </header>

      <AddItemModal open={addOpen} onOpenChange={setAddOpen} />
      <SearchPalette open={searchOpen} onOpenChange={setSearchOpen} />
    </>
  );
}
